import { Button, type ButtonProps } from "@chakra-ui/react";

import { useNotImplementedYetToast } from "shared/Toast";
import { t } from "utils";

type IProps = ButtonProps;

const ContactUsButton = (props: IProps) => {
  const notImplemented = useNotImplementedYetToast();

  return (
    <Button onClick={notImplemented} {...props}>
      {t("Contact us!")}
    </Button>
  );
};

export { ContactUsButton };
